import * as React from 'react';

export default class PopoverToast extends React.Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount(){
        setTimeout(() => {
            this.props.onClose()
        }, 5000);
    }

    onClose() {
        this.props.onClose();
    }

    render(){
        return(
            <div className="modalBody alignMiddle colFlex switchAccount">
                <h1 className="mb">You are now logged in with</h1>
                <div className="userPic mb"><img width="90" height="90" src={this.props.OrganizationImage.replace("default_org_s", "default_org")} /></div>
                <p className="mb">{this.props.OrganizationName}</p>
                <a href="javascript:void(0)" onClick={this.onClose}>Close</a>
            </div>
        )
    }    
}